import { render, staticRenderFns } from "./SiInputCombo.vue?vue&type=template&id=429ff04c&scoped=true&lang=html&"
import script from "./SiInputCombo.vue?vue&type=script&lang=js&"
export * from "./SiInputCombo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429ff04c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
